function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

module.exports = _objectDestructuringEmpty;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/objectDestructuringEmpty.js
// module id = 378
// module chunks = 25